'use strict';

module.exports = {
    classes: {
        // GalleryWrapperView.es.js
        GALLERY: 'gallery',
        STATE_SHOW_DETAILS: 'show-details',

        // PhotoDetails.es.js
        PHOTO_DETAILS: 'photoDetails',

        PHOTO_TITLE: 'photoDetails-js-photoTitle',
        PHOTO_CAPTION: 'photoDetails-js-photoCaption',
        PHOTO_ATTRIBUTES: 'photoDetails-js-photoAttributes',

        PROJECT_NAME: 'photoDetails-js-projectName',
        PROJECT_LINK: 'photoDetails-js-projectLink',
        PROJECTS_LINK: 'photoDetails-js-projectsLink',

        FIRM_NAME: 'photoDetails-js-firmName',
        FIRM_LINK: 'photoDetails-js-firmLink',
        FIRM_IMAGE: 'photoDetails-js-firmImage',

        // SimilarItems
        SIMILAR_ITEMS: 'photoDetails-js-similarItems',
        SIMILAR_ITEMS_ALL: 'similarItems-seeAllLink',
        SIMILAR_ITEM_PDP: 'similarItems-itemLink',

        // MoreProjects
        MORE_PROJECTS: 'photoDetails-js-moreProjects',

        // GalleryArrowBox.es.js
        ARROW_BOX: 'gallery-arrowBox',

        // GalleryMobileNavWrapper.es.js
        MOBILE_NAV: 'gallery-mobileNavigationWrapper',
    },

    galleryPhotoClasses: {
        galleryPhotoWrapper: 'galleryPhoto-wrapper',
        galleryPhotoImage: 'galleryPhoto-image',
        galleryPhotoFadeIn: 'fade-in',
    },

    /**
     * Classes used in GalleryModalWrapperView
     */
    galleryModalClasses: {
        PHOTO_PROJECT_LINK: 'photoDetails-js-projectLink',
        CLOSE_GALLERY_LINK: 'galleryModal-close',

        CONTENT_GALLERY: 'galleryModal-content',
        STATE_NOT_LOADED: 'not-loaded',

        SIMPLE_MODAL_CLASSES: {
            modal: 'galleryModal is-full-page not-loaded',
            contentWrapper: 'galleryModal-contentWrapper boxSizingWrapper containerFluid',
        },
    },

    pageTypes: {
        PDP: 'pdp',
    },

    switchActions: {
        NEXT: 'next',
        PREVIOUS: 'previous',
    },

    ITEM_TAG_INFO_CHAR_LIMIT: 40,
};



// WEBPACK FOOTER //
// ./assets/js/gallery/helpers/GalleryConstants.es.js